import React from 'react';
import {MainBannerComponent, BannerComponent, ContactDetailsComponent, TextComponent,BlockQuoteComponent,
  ServicesIconsComponent} from '../../../../common/CMS/components';


export const Content1 = (props) => {

  const {bannerSection, blockQuoteSection,  mainBannerSection, servicesIconsSection, textSectionOne, textSectionTwo, textSectionThree, contactDetailsSection} = props.data.content;

  return <div className="content-one">

    { mainBannerSection && <MainBannerComponent content={mainBannerSection}/> }

    <ServicesIconsComponent content={servicesIconsSection}/>

    { textSectionOne && <TextComponent content={textSectionOne.columns}/> }


    { blockQuoteSection && <BlockQuoteComponent content={blockQuoteSection}/> }


    { textSectionTwo && <TextComponent content={textSectionTwo.columns}/> }


    { bannerSection && <BannerComponent {...bannerSection} /> }


    { textSectionThree && <TextComponent content={textSectionThree.columns}/> }


    { contactDetailsSection && <ContactDetailsComponent content={contactDetailsSection}/> }

  </div>
};



// WEBPACK FOOTER //
// src/client/components/site/features/partnerships/templates/Content1.js